export const INVESTORS ="INVESTORS"
export const INVESTORS_RESPONSE = "INVESTORS_RESPONSE"
export const EDIT_INVESTORS = "EDIT_INVESTORS"
export const EDIT_INVESTORS_RESPONSE = "EDIT_INVESTORS_RESPONSE"
export const ADD_INVESTOR ="ADD_INVESTOR"
export const ADD_INVESTOR_RESPONSE = "ADD_INVESTOR_RESPONSE"